import {
    array,
    assign,
    literal,
    nullable,
    number,
    object,
    omit,
    optional,
    string,
} from "superstruct";

import { RewardsFreeProductVariantSchema } from "../RewardsFreeProductSchemas/RewardsFreeProductVariantSchema";

export const FreeProductRewardSchema = object({
    type: literal("free_product"),
    discountValue: number(),
    productId: number(),
    productHandle: optional(string()),
    productTitle: optional(string()),
    productImage: optional(nullable(string())),
    expirationInDays: nullable(number()),
    variants: array(RewardsFreeProductVariantSchema),
});

export const FreeProductDiscountCodeRewardSchema = assign(
    omit(FreeProductRewardSchema, ["variants", "expirationInDays"]),
    object({
        discountCode: string(),
        variantId: number(),
        variantTitle: optional(string()),
        variantImage: optional(nullable(string())),
    })
);
